<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_1"></a>IMAGESOF WAR</p>
<h1 class="title">HITLER’S</h1>
<h1 class="title">DEATH CAMPS</h1>
<h1 class="title">IN OCCUPIED</h1>
<h1 class="title">POLAND</h1>
<p class="sub-title">RARE PHOTOGRAPHS FROM</p>
<p class="sub-title1">WARTIME ARCHIVES</p>
<p class="author">Ian Baxter</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2e367593